import React from 'react';
import PropTypes from 'prop-types';

import AccessModalListItem from './ModalListItem';

const AccessModalAccessList = (props) => {
  const {
    groups,
    users,
    selectedGroups,
    selectedUsers,
  } = props;
  const items = groups.concat(users);
  const selected = {
    ...selectedGroups,
    ...selectedUsers,
  };

  const getItem = (uuid) => (
    items.find(i => (i.uuid === uuid))
  );

  return (
    <div className="access-list users-list">
      {Object.keys(selected).map((uuid) => {
        const item = getItem(uuid);
        if (!item) {
          return false;
        }
        return (
          <AccessModalListItem
            {...props}
            key={uuid}
            item={{
              uuid,
              type: item.email ? 'user' : 'group',
              name: item.name ? item.name : '',
              email: item.email ? item.email : undefined,
              avatar_url: item.avatar_url ? item.avatar_url : null,
              count: selected[uuid],
              hasAccessToCollectionGroup: true,
            }}
          />
        );
      })}
    </div>
  );
};

AccessModalAccessList.propTypes = {
  groups: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
  selectedGroups: PropTypes.object,
  selectedUsers: PropTypes.object,
};

AccessModalAccessList.defaultProps = {
  selectedGroups: {},
  selectedUsers: {},
};

export default AccessModalAccessList;
